module.exports = __webpack_public_path__ + "static/media/HomePage.628e23d3.png";